export interface FinanceAccessModel {
  // General access section.
  canReadFinanceRegister: boolean;
  canCreateScores: boolean;
  canUpdateScores: boolean;
  canRemoveScores: boolean;
  canCreateCategory: boolean
  canRemoveCategory: boolean;
  canUpdateCategory: boolean;
}


export const FINANCE_ACCESS_DEFAULT: FinanceAccessModel = {
  canReadFinanceRegister: false,
  canCreateScores: false,
  canRemoveScores: false,
  canUpdateScores: false,
  canCreateCategory: false,
  canRemoveCategory: false,
  canUpdateCategory: false,
};

